import { EmptyState } from '@all-manager/design-system-v2';

type Props = {
  title: string;
  subtitle?: string;
  image?: React.ReactNode;
};

export function NoItems(props: Props) {
  return <EmptyState title={props.title} subtitle={props.subtitle} image={props.image} />;
}
